// const folder_base =
//   "https://upstyledus.oss-us-east-1.aliyuncs.com/unionwear_resource/sketch_images";

const folder_base =
  "https://upstyledus.oss-us-east-1.aliyuncs.com/unionwear_resource/sketch_revised_1024";

export const viewpointOptions = [
  {
    label: "3Q",
    value: "3q",
    customized_options: [
      {
        src: `${folder_base}/3q/5XXL.png`,
        name: "5XXL",
        eyelet: false,
        shape: "five panel",
      },
      {
        src: `${folder_base}/3q/5XXSE.png`,
        name: "5XXSE",
        eyelet: true,
        shape: "five panel",
      },
      {
        src: `${folder_base}/3q/5XXSO.png`,
        name: "5XXSO",
        eyelet: false,
        shape: "five panel",
      },
      {
        src: `${folder_base}/3q/5XXUE.png`,
        name: "5XXUE",
        eyelet: true,
        shape: "five panel",
      },
      {
        src: `${folder_base}/3q/5XXUO.png`,
        name: "5XXUO",
        eyelet: false,
        shape: "five panel",
      },
      {
        src: `${folder_base}/3q/6XXHE.png`,
        name: "6XXHE",
        eyelet: true,
        shape: "six panel",
      },
      {
        src: `${folder_base}/3q/6XXHO.png`,
        name: "6XXHO",
        eyelet: false,
        shape: "six panel",
      },
      {
        src: `${folder_base}/3q/6XXLE.png`,
        name: "6XXLE",
        eyelet: true,
        shape: "six panel",
      },
      {
        src: `${folder_base}/3q/6XXLO.png`,
        name: "6XXLO",
        eyelet: false,
        shape: "six panel",
      },
      {
        src: `${folder_base}/3q/6XXSE.png`,
        name: "6XXSE",
        eyelet: true,
        shape: "six panel",
      },
      {
        src: `${folder_base}/3q/6XXSO.png`,
        name: "6XXSO",
        eyelet: false,
        shape: "six panel",
      },
      {
        src: `${folder_base}/3q/CAMPER.png`,
        name: "CAMPER",
        eyelet: false,
        shape: "camper",
      },
      {
        src: `${folder_base}/3q/6XXUE.png`,
        name: "6XXUE",
        eyelet: true,
        shape: "six panel",
      },
      {
        src: `${folder_base}/3q/6XXUO.png`,
        name: "6XXUO",
        eyelet: false,
        shape: "six panel",
      },
      {
        src: `${folder_base}/3q/VISOR.png`,
        name: "VISOR",
        eyelet: false,
        shape: "sun visor",
      },
    ],
  },
  {
    label: "Front",
    value: "front",
    customized_options: [
      {
        src: `${folder_base}/front/5XXX.png`,
        name: "5XXX",
        eyelet: false,
        shape: "five panel",
      },
      {
        src: `${folder_base}/front/6XXXE.png`,
        name: "6XXXE",
        eyelet: true,
        shape: "six panel",
      },
      {
        src: `${folder_base}/front/6XXXO.png`,
        name: "6XXXO",
        eyelet: false,
        shape: "six panel",
      },
      {
        src: `${folder_base}/front/6XXUE.png`,
        name: "6XXUE",
        eyelet: true,
        shape: "six panel",
      },
      {
        src: `${folder_base}/front/6XXUO.png`,
        name: "6XXUO",
        eyelet: false,
        shape: "six panel",
      },
      {
        src: `${folder_base}/front/CAMPER.png`,
        name: "CAMPER",
        eyelet: false,
        shape: "camper",
      },
      {
        src: `${folder_base}/front/VISOR.png`,
        name: "VISOR",
        eyelet: false,
        shape: "sun visor",
      },
    ],
  },
  {
    label: "Side",
    value: "side",
    customized_options: [
      {
        src: `${folder_base}/side/6XXXE.png`,
        name: "6XXXE",
        eyelet: true,
      },
      {
        src: `${folder_base}/side/6XXXO.png`,
        name: "6XXXO",
        eyelet: false,
      },
      {
        src: `${folder_base}/side/CAMPER.png`,
        name: "CAMPER",
        eyelet: false,
      },
      {
        src: `${folder_base}/side/VISOR.png`,
        name: "VISOR",
        eyelet: false,
      },
    ],
  },
  {
    label: "Back",
    value: "back",
    customized_options: [
      {
        src: `${folder_base}/back/FE.png`,
        name: "FE",
        eyelet: true,
      },
      {
        src: `${folder_base}/back/FO.png`,
        name: "FO",
        eyelet: false,
      },
      {
        src: `${folder_base}/back/LE.png`,
        name: "LE",
        eyelet: true,
      },
      {
        src: `${folder_base}/back/LO.png`,
        name: "LO",
        eyelet: false,
      },
      {
        src: `${folder_base}/back/PE.png`,
        name: "PE",
        eyelet: true,
      },
      {
        src: `${folder_base}/back/PO.png`,
        name: "PO",
        eyelet: false,
      },
      {
        src: `${folder_base}/back/SE.png`,
        name: "SE",
        eyelet: true,
      },
      {
        src: `${folder_base}/back/SO.png`,
        name: "SO",
        eyelet: false,
      },
      {
        src: `${folder_base}/back/TE.png`,
        name: "TE",
        eyelet: true,
      },
      {
        src: `${folder_base}/back/TO.png`,
        name: "TO",
        eyelet: false,
      },
      {
        src: `${folder_base}/back/VE.png`,
        name: "VE",
        eyelet: true,
      },
      {
        src: `${folder_base}/back/VO.png`,
        name: "VO",
        eyelet: false,
      },
    ],
  },
];

export const sketch_images = {
  "3q": viewpointOptions[0]["customized_options"].map((x) => x.name),
  front: viewpointOptions[1]["customized_options"].map((x) => x.name),

  side: viewpointOptions[2]["customized_options"].map((x) => x.name),
  back: viewpointOptions[3]["customized_options"].map((x) => x.name),
};
